import styled, { css } from 'styled-components';
import { combineValues } from '@clds/component-theme';
import { Chip } from './Chip';
import { chipTheme } from './theme';
export const SelectableChip = styled(Chip) `
  ${({ selected }) => !selected &&
    css `
      background-color: ${chipTheme.selectable.background.color.unselected};
    `};
  padding: ${combineValues(chipTheme.md.padding.vertical, chipTheme.selectable.border.width, (paddingSize, borderWidth) => `calc(${paddingSize} - ${borderWidth})`)}
    ${chipTheme.md.padding.horizontal};
  border: ${chipTheme.selectable.border.width} solid
    ${chipTheme.selectable.border.color};
  cursor: pointer;
`;
//# sourceMappingURL=SelectableChip.js.map